import React from 'react';
import PropTypes from 'prop-types';

const Canvas = ({ imageUrl }) => {
  const canvas = React.useRef();

  React.useEffect(() => {
    const context = canvas.current.getContext('2d');

    const img = new Image();

    img.onload = () => {
      const containerWidth = document.getElementById('emailSharingPopup')
        .offsetWidth;
      const imageWidth = 0.8 * containerWidth;
      const imageHeight = 0.8 * (containerWidth / img.width) * img.height;

      canvas.current.width = imageWidth;
      canvas.current.height = imageHeight;

      context.drawImage(img, 0, 0, imageWidth, imageHeight);
    };

    img.src = imageUrl;
  });

  return <canvas id="previewImage" ref={canvas} />;
};

Canvas.propTypes = {
  imageUrl: PropTypes.string.isRequired,
};
export default Canvas;
